import { render, staticRenderFns } from "./ResearchAndDevelopmentPage.vue?vue&type=template&id=2b2c0a68&scoped=true&"
import script from "./ResearchAndDevelopmentPage.vue?vue&type=script&lang=js&"
export * from "./ResearchAndDevelopmentPage.vue?vue&type=script&lang=js&"
import style0 from "./ResearchAndDevelopmentPage.vue?vue&type=style&index=0&id=2b2c0a68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2c0a68",
  null
  
)

export default component.exports